import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "../index.css";
import {
  LEFT,
  TRANSLATION_KEY_PREVIOUS,
  TRANSLATION_KEY_NEXT
} from "../constants";
import { withTranslation } from "../../translation";

const CarouselButton = ({
  direction,
  scroll,
  formatTranslation,
  disabled = false
}) => {
  const baseClassName =
    direction === LEFT ? styles.backChevron : styles.forwardChevron;
  const className = classnames(baseClassName, {
    [styles.disabled]: disabled
  });

  const translationKey =
    direction === LEFT ? TRANSLATION_KEY_PREVIOUS : TRANSLATION_KEY_NEXT;

  return (
    <button
      onClick={() => scroll(direction)}
      className={className}
      aria-label={formatTranslation(translationKey)}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    />
  );
};

CarouselButton.propTypes = {
  direction: PropTypes.string.isRequired,
  scroll: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default withTranslation(CarouselButton);
